import styled from 'styled-components';

export const FiltersWrapper = styled.div`
  gap: 28px;
  @media ${(props) => props.theme.device.mobileL} {
    flex-direction: column;
    gap: 8px;
    align-items: flex-start;
  }
`;

export const Legend = styled.div`
  display: grid;
  grid-template-columns: 100px 2fr repeat(3, 1fr) 100px;
  gap: 16px;
  padding: 0 24px;
  margin-bottom: 10px;
  .h3-5 {
    text-transform: uppercase;
    color: ${(props) => props.theme.colors.textSecondary};
  }

  &.old {
    grid-template-columns: 100px 2fr repeat(4, 1fr) 30px;
  }
`;

export const RequestCard = styled(Legend)`
  border-radius: 4px;
  background: ${(props) => props.theme.colors.white};
  box-shadow: 0px 4px 20px 0px rgba(104, 104, 104, 0.1);
  align-items: center;
  padding: 24px;

  .code {
    text-transform: uppercase;
    color: ${(props) => props.theme.colors.textSecondary};
  }

  @media ${(props) => props.theme.device.mobileL} {
    grid-template-columns: 140px 1fr;
    align-items: start;

    &.old {
      grid-template-columns: 140px 1fr;
    }

    > :nth-child(even) {
      text-align: right;
    }
  }
`;

export const CardsWrapper = styled.div`
  padding-bottom: 40px;
`;
